import React from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import PropTypes from "prop-types";

function Dropdown({ label, value, options, onChange, width, size = "small", placeholder, disabled = false, ariaLabel, minHeight }) {
  return (
    <ArgonBox display="flex" alignItems="center" sx={{ cursor: "pointer" }}>
      {/* Label */}
      {label && (
        <ArgonTypography variant="body2" fontWeight="medium">
          {label}
        </ArgonTypography>
      )}

      <select
        disabled={disabled}
        aria-label={ariaLabel || label || undefined}
        value={value}
        onChange={onChange}
        style={{
          marginLeft: label ? 8 : 0,
          width: width || 350,
          height: minHeight || (size === "small" ? "39px" : "40px"),
          minHeight: minHeight || (size === "small" ? "39px" : "40px"),
          boxSizing: "border-box",
          padding: minHeight ? "4px 12px" : "6px 12px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          cursor: disabled ? "not-allowed" : "pointer",
          backgroundColor: disabled ? "#e9ecef" : "#fff",
          outline: "none",
          color: "#7b7a7aff",
          fontWeight: "500",
          fontSize: "14px",
          transition: "all 0.2s ease-in-out",
        }}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option, idx) => {
          // agar string hai to string hi use hoga
          if (typeof option === "string") {
            return (
              <option key={idx} value={option}>
                {option}
              </option>
            );
          }

          if (Array.isArray(option.options)) {
            return (
              <optgroup key={option.label || idx} label={option.label}>
                {option.options.map((groupOption, groupIdx) => (
                  <option
                    key={groupOption.value || groupIdx}
                    value={groupOption.value}
                    disabled={groupOption.disabled}
                  >
                    {groupOption.label}
                  </option>
                ))}
              </optgroup>
            );
          }

          // agar object hai to label/value use karo
          return (
            <option
              key={idx}
              value={option.value}
              disabled={option.disabled}
              style={{
                opacity: option.disabled ? 0.5 : 1,
                color: option.disabled ? "#bdbdbd" : "#344767",
                cursor: option.disabled ? "not-allowed" : "pointer",
              }}
            >
              {option.label}
            </option>
          );
        })}
      </select>
    </ArgonBox>
  );
}

// ✅ PropTypes flexible banaya
Dropdown.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        disabled: PropTypes.bool,
        options: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            disabled: PropTypes.bool,
          })
        ),
      }),
    ])
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOf(["small", "medium"]),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
  minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Dropdown;

